import { useTranslation } from '@exam-room/translations';

import { Button, LoadingSpinner, Modal, type ModalProps } from '../../../components';

type ExamEndingSubmissionModalProps = Omit<ModalProps, 'children'> & {
  onSubmitExam: () => void;
  submitting: boolean;
  isOnline?: boolean;
  openedOffline?: boolean;
};

export default function ExamEndingSubmissionModal({
  open,
  onSubmitExam,
  submitting: isSubmitting,
  isOnline = true,
  openedOffline = false,
}: Readonly<ExamEndingSubmissionModalProps>) {
  const { t } = useTranslation();

  const variant = openedOffline ? 'offline' : 'online';

  const isButtonDisabled = !isOnline || isSubmitting;

  return (
    <Modal open={open} className='grid max-w-xl gap-6'>
      <h3>{t('examEndingSubmissionModal.title')}</h3>
      <p className='font-normal'>
        {variant === 'offline' ? (
          <>
            {t('examEndingSubmissionModal.offline.detail.1')}
            <br />
            <span className='font-semibold'>{t('examEndingSubmissionModal.offline.detail.2')}</span>
          </>
        ) : (
          <>
            {t('examEndingSubmissionModal.detail.1')}
            <br />
            <span className='font-semibold'>{t('examEndingSubmissionModal.detail.2')}</span>
          </>
        )}
      </p>
      <div className='flex justify-end'>
        <Button className='w-[121px] text-black' onClick={onSubmitExam} disabled={isButtonDisabled}>
          {isSubmitting ? <LoadingSpinner /> : t('examEndingSubmissionModal.button')}
        </Button>
      </div>
    </Modal>
  );
}
